module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 8rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("运动员/教练/领队食宿安排")]), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "食宿人数",
      "label": "运动员/教练/领队",
      "value": _vm.sai_member_count
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "食宿缴费人数",
      "label": "运动员/教练/领队",
      "value": _vm.orderData.countExceptCaipan
    }
  }), _vm._v(" "), _vm._l((_vm.orderData.list.filter(function (item) {
    return item.show_caipan == 2
  })), function(room, rindex) {
    return _c('van-cell', {
      key: rindex,
      attrs: {
        "input-align": "right",
        "label": room.stock > 0 ? '仅剩' + room.last_stock + '间' : '',
        "title": room.name,
        "value": room.count
      }
    }, [(room.edit_admin == 2) ? _c('span', [_c('van-stepper', {
      attrs: {
        "integer": "",
        "min": 0,
        "max": room.stock > 0 ? room.last_stock : 999999999
      },
      on: {
        "change": _vm.countChange
      },
      model: {
        value: (room.count),
        callback: function($$v) {
          _vm.$set(room, "count", $$v)
        },
        expression: "room.count"
      }
    })], 1) : _c('span', [_vm._v("\n                " + _vm._s(room.count) + "人\n                "), _c('div', {
      staticClass: "operate-desc-left"
    }, [_vm._v("请联系食宿负责人修改")])])])
  }), _vm._v(" "), (_vm.row.caipan_count > 0 && _vm.orderData.list.filter(function (item) {
    return item.show_caipan == 1
  }).length > 0) ? _c('div', [_c('van-divider', [_vm._v("裁判员食宿安排")]), _vm._v(" "), _vm._l((_vm.orderData.list.filter(function (item) {
    return item.show_caipan == 1
  })), function(room, rindex) {
    return _c('van-cell', {
      key: rindex,
      attrs: {
        "input-align": "right",
        "title": room.name,
        "value": room.count
      }
    }, [(room.edit_admin == 2) ? _c('span', [_c('van-stepper', {
      attrs: {
        "integer": "",
        "min": 0,
        "max": room.stock > 0 ? room.last_stock : 1
      },
      on: {
        "change": function($event) {
          return _vm.caipanCountChange(room)
        }
      },
      model: {
        value: (room.count),
        callback: function($$v) {
          _vm.$set(room, "count", $$v)
        },
        expression: "room.count"
      }
    })], 1) : _c('span', [_vm._v("\n                    " + _vm._s(room.count) + "人\n                    "), _c('div', {
      staticClass: "operate-desc-left"
    }, [_vm._v("请联系食宿负责人修改")])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('van-divider', [_vm._v("食宿费用信息")]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "食宿费用",
      "value": _vm.orderData.price + '元'
    }
  })], 2), _vm._v(" "), (_vm.row.saiqu.is_jiesong == 1) ? _c('van-notice-bar', {
    attrs: {
      "wrapable": "",
      "scrollable": false,
      "text": "此项费用包含: 车站到酒店的接送站费用、住宿费、餐费及赛场到酒店的接驳费（如涉及）。"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.row.saiqu.is_jiesong == 2) ? _c('van-notice-bar', {
    attrs: {
      "wrapable": "",
      "scrollable": false,
      "text": "本次比赛不提供接送站服务，此项费用包含: 住宿费、餐费及赛场到酒店的接驳费（如涉及）。"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ISaiApplyFormStep3',
        query: {
          id: this.$route.query.id
        }
      }),
      expression: "{name:'ISaiApplyFormStep3',query:{id:this.$route.query.id}}"
    }],
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "native-type": "button"
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04873bf4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormStep4.vue
// module id = 2177
// module chunks = 0